<template>
    <div class="float-left mr-1" 
        v-if="despesa.justificativaRateio"   
    ><span class="text-warning">
            <i
                class="fa fa-file-text fa-lg icon-button"
                title="Justificativa"
                @click.stop="mostrarJustificativa()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        despesa: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        mostrarJustificativa() {
            this.$swal({
                title: 'Justificativa',
                html: `${this.despesa.justificativaRateio}`,
                icon: 'warning'
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
